import React from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Chip,
  alpha,
  useTheme,
} from "@mui/material";
import { ArrowBack, Print } from "@mui/icons-material";

const OrderHeader = ({
  orderDetails,
  statusConfig,
  createdDateTime,
  onBack,
  onPrint,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        background: `linear-gradient(135deg, ${statusConfig.color} 0%, ${alpha(statusConfig.color, 0.8)} 100%)`,
        borderBottom: "none",
        boxShadow: `0 4px 15px ${alpha(statusConfig.color, 0.3)}`,
        p: 3,
        flexShrink: 0,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left Side - Order Info */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: "#fff",
              letterSpacing: "-0.5px",
              mb: 0.5,
            }}
          >
            Order #
            {orderDetails.orderNumber
              ? orderDetails.orderNumber.split("-").pop()
              : `${orderDetails.id?.toString().slice(-4) || "N/A"}`}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: alpha("#fff", 0.95),
              fontSize: "1rem",
              fontWeight: 500,
            }}
          >
            {createdDateTime.date} at {createdDateTime.time}
          </Typography>
        </Box>

        {/* Right Side - Action Buttons Aligned */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Chip
            icon={<statusConfig.icon sx={{ fontSize: "18px !important" }} />}
            label={statusConfig.label}
            sx={{
              height: 48,
              fontSize: "0.95rem",
              fontWeight: 700,
              px: 2,
              bgcolor: "white",
              color: statusConfig.color,
              border: `2px solid white`,
              boxShadow: `0 4px 12px ${alpha("#000", 0.2)}`,
              "& .MuiChip-icon": {
                color: statusConfig.color,
              },
            }}
          />
          <IconButton
            onClick={onPrint}
            sx={{
              width: 48,
              height: 48,
              borderRadius: "12px",
              bgcolor: "white",
              color: statusConfig.color,
              border: `2px solid white`,
              boxShadow: `0 4px 12px ${alpha("#000", 0.2)}`,
              "&:hover": {
                bgcolor: alpha("#fff", 0.9),
                transform: "scale(1.05)",
                boxShadow: `0 6px 16px ${alpha("#000", 0.25)}`,
              },
              transition: "all 0.2s ease",
            }}
          >
            <Print sx={{ fontSize: 22 }} />
          </IconButton>
          <IconButton
            onClick={onBack}
            sx={{
              width: 48,
              height: 48,
              borderRadius: "12px",
              bgcolor: "white",
              color: statusConfig.color,
              border: `2px solid white`,
              boxShadow: `0 4px 12px ${alpha("#000", 0.2)}`,
              "&:hover": {
                bgcolor: alpha("#fff", 0.9),
                transform: "scale(1.05)",
                boxShadow: `0 6px 16px ${alpha("#000", 0.25)}`,
              },
              transition: "all 0.2s ease",
            }}
          >
            <ArrowBack sx={{ fontSize: 22 }} />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};

export default OrderHeader;
